import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context';

interface LoginFormProps {
  onSuccess?: () => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const success = await login(formData);
    if (!success) {
      setError(t('auth.invalid_credentials'));
    } else if (onSuccess) {
      onSuccess();
    }
    setLoading(false);
  };

  return (
    <div>
      <h2 className='text-center mb-8 text-gray-800 text-2xl font-semibold'>
        Accès Modérateurs
      </h2>
      <form onSubmit={handleSubmit}>
        <div className='mb-5'>
          <label
            htmlFor='username'
            className='block mb-1 text-gray-600 font-medium'
          >
            Nom d'utilisateur ou e-mail
          </label>
          <input
            type='text'
            id='username'
            name='username'
            value={formData.username}
            onChange={handleChange}
            placeholder='admin ou admin@minihi-levenez.org'
            required
            disabled={loading}
            className='w-full p-3 border-2 border-gray-200 rounded-lg text-base transition-colors focus:outline-none focus:border-church-brown focus:shadow-sm disabled:bg-gray-50 disabled:cursor-not-allowed'
          />
        </div>

        <div className='mb-5'>
          <label
            htmlFor='password'
            className='block mb-1 text-gray-600 font-medium'
          >
            {t('auth.password')}
          </label>
          <input
            type='password'
            id='password'
            name='password'
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
            className='w-full p-3 border-2 border-gray-200 rounded-lg text-base transition-colors focus:outline-none focus:border-church-brown focus:shadow-sm disabled:bg-gray-50 disabled:cursor-not-allowed'
          />
        </div>

        {error && (
          <div className='bg-red-50 text-red-600 p-3 rounded-md mb-4 border-l-4 border-red-600 text-sm'>
            {error}
          </div>
        )}

        <button
          type='submit'
          className='w-full p-3 bg-gradient-to-r from-church-brown to-church-dark text-white border-0 rounded-lg text-base font-semibold cursor-pointer transition-all hover:-translate-y-1 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none mt-3'
          disabled={loading}
        >
          {loading ? t('auth.signing_in') : t('auth.sign_in')}
        </button>
      </form>

      <p className='text-center mt-5 text-gray-500 text-sm'>
        Accès réservé aux modérateurs uniquement
      </p>
    </div>
  );
};
